// extracted by css-extract-rspack-plugin
export default {"mapContainer":"mapContainer-QIJ12H"};